import React from 'react';
import { Star } from 'lucide-react';
import { useTranslation, Trans } from 'react-i18next';
import { SOCIAL_PROOF_LINKS } from '../../config/planComparisonRows';
import './SocialProofStrip.css';

type SocialProofStripProps = {
  /** marketing namespace key prefix, default landingV2 */
  i18nPrefix?: string;
};

export default function SocialProofStrip({ i18nPrefix = 'landingV2' }: SocialProofStripProps) {
  const { t } = useTranslation('marketing');
  const ns = i18nPrefix;

  return (
    <section className="social-proof-strip" aria-labelledby="social-proof-strip-title">
      <div className="social-proof-strip__inner">
        <div className="social-proof-strip__stars" aria-hidden>
          {[1, 2, 3, 4, 5].map((i) => (
            <Star key={i} size={18} fill="#f59e0b" color="#f59e0b" />
          ))}
        </div>
        <p id="social-proof-strip-title" className="social-proof-strip__quote">
          {t(`${ns}.socialProof.quote`)}
        </p>
        <p className="social-proof-strip__adopted">
          <Trans
            i18nKey={`${ns}.socialProof.adoptedRich`}
            ns="marketing"
            components={{
              highlight: <span className="social-proof-strip__highlight" />,
            }}
          />
        </p>
        <ul className="social-proof-strip__links">
          {SOCIAL_PROOF_LINKS.map((link) => (
            <li key={link.href}>
              <a href={link.href} target="_blank" rel="noopener noreferrer">
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
